import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";
import { Trash2, Download } from "lucide-react";

export default function BookingsAdmin() {
  const [items, setItems] = useState([]);
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => {
    const q = filter ? `?event_id=${filter}` : "";
    api.get(`/admin/bookings${q}`).then((r) => setItems(r.data));
  };
  useEffect(() => { api.get("/events?limit=500").then((r) => setEvents(r.data)); }, []);
  useEffect(() => { load(); }, [filter]);

  const del = async (id) => {
    if (!confirm("Eliminare questa prenotazione?")) return;
    await api.delete(`/admin/bookings/${id}`);
    toast.success("Eliminata"); load();
  };

  const exportCsv = async () => {
    if (!filter) return toast.error("Seleziona un evento");
    const { data } = await api.get(`/admin/events/${filter}/bookings.csv`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = "iscritti.csv"; a.click();
  };

  const eventMap = Object.fromEntries(events.map((e) => [e.id, e.title]));

  return (
    <div data-testid="admin-bookings">
      <h1 className="font-display text-4xl font-medium">Prenotazioni</h1>
      <p className="text-sm text-[#292522]/60 mt-1 mb-6">Consulta e gestisci le iscrizioni ricevute.</p>

      <div className="flex gap-3 mb-6">
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="rounded-full bg-white border border-[#292522]/10 px-4 py-2 text-sm" data-testid="filter-event">
          <option value="">Tutti gli eventi</option>
          {events.map((e) => <option key={e.id} value={e.id}>{e.title}</option>)}
        </select>
        {filter && <button onClick={exportCsv} className="btn-ghost text-sm"><Download className="h-4 w-4" strokeWidth={1.75} />Esporta CSV</button>}
      </div>

      <div className="rounded-2xl bg-white border border-[#292522]/8 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-[#F8F1E8] text-xs uppercase">
            <tr><th className="text-left p-3">Evento</th><th className="text-left p-3">Iscritto</th><th className="text-left p-3">Contatti</th><th className="text-left p-3">Partecipanti</th><th className="text-left p-3">Stato</th><th className="text-left p-3">Data</th><th className="p-3"></th></tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={7} className="p-6 text-center text-[#292522]/50">Nessuna prenotazione.</td></tr>
            ) : items.map((b) => (
              <tr key={b.id} className="border-t border-[#292522]/8" data-testid={`booking-${b.id}`}>
                <td className="p-3">{eventMap[b.event_id] || b.event_id}</td>
                <td className="p-3">{b.first_name} {b.last_name}</td>
                <td className="p-3 text-xs">{b.email}<br />{b.phone}</td>
                <td className="p-3">{b.total_participants} <span className="text-xs text-[#292522]/50">({b.adults}a / {b.children}b)</span></td>
                <td className="p-3"><span className={`rounded-full font-semibold text-xs px-2 py-0.5 ${b.status === "confirmed" ? "bg-[#216B65] text-white" : b.status === "waitlist" ? "bg-[#FF6100] text-white" : "bg-[#292522]/10"}`}>{b.status}</span></td>
                <td className="p-3 text-xs">{formatDate(b.created_at)}</td>
                <td className="p-3 text-right"><button onClick={() => del(b.id)} className="p-1.5 hover:text-red-600"><Trash2 className="h-4 w-4" strokeWidth={1.75} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
